import queryString from 'query-string';

export default (nextUrl, search) => {
  const { nextPath } = queryString.parse(search);
  if (nextPath) {
    return `${nextUrl}?${queryString.stringify({ nextPath })}`;
  }
  return nextUrl;
};
